import { DatabaseLayoutType } from '@databases/types/database/view';

export const stringToDatabaseLayoutType = (
  str: string
): DatabaseLayoutType | undefined => {
  return DatabaseLayoutType[str.toUpperCase() as keyof typeof DatabaseLayoutType];
};
